import { useDispatch } from 'react-redux';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import eye from '../../../assets/images/eye.svg';
import paper from '../../../assets/images/paper.svg';
import { ModalTypes } from '../../../reducers/modal';
import { actionShowModal } from '../../../actions/modal';

export interface IStatsMobileProps {
  data: any; // we don't have correct type for this
  address: string | undefined;
  chain: string;
  timezone?: string;
  date?: number;
  short?: boolean;
  exchange?: string;
}

const StatsMobile = ({
  data,
  address,
  chain,
  timezone,
  date,
  short,
  exchange,
}: IStatsMobileProps) => {
  const dispatch = useDispatch();

  const openModal = () =>
    dispatch(
      actionShowModal(ModalTypes.wallet, {
        wallet: data.wallet,
        address: address,
        chain: chain,
        timeframe: date ? 'latest' : 'week',
        exchange: exchange,
        date: date,
        timezone: timezone,
      })
    );

  const tradesCount = data.tradesNum
    ? data.tradesNum
    : data.buy_count + data.sell_count;

  return (
    <div className='table_mobile__card__footer__row'>
      <div className='table_mobile__card__footer__row__text'>
        <Text size={12}>Statistics</Text>
      </div>
      <div className='table_mobile__card__footer__row__activity_group'>
        {!short && data.bot && (
          <div className='table_mobile__card__footer__row__activity_group__icon'>
            <Image data-tip='Bot / Smart Contract' src={paper} size='m' />
          </div>
        )}
        <div className='table_mobile__card__footer__row__activity_group__icon'>
          <div className='table_mobile__card__footer__row__activity_group__icon__number'>
            <Text size={10} className='text--grey-200 text--weight-500'>
              {tradesCount}
            </Text>
          </div>
        </div>
        <div
          onClick={openModal}
          className='table_mobile__card__footer__row__activity_group__icon'
        >
          <Image
            data-tip='Show more trades with this wallet'
            src={eye}
            size='s'
          />
        </div>
      </div>
    </div>
  );
};

export default StatsMobile;
